/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const Eyes1 = ({ className }) => {
  return (
    <svg
      className={`eyes-1 ${className}`}
      fill="none"
      height="13"
      viewBox="0 0 3 13"
      width="3"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        className="rect"
        fill="#EDB98A"
        height="12.1"
        transform="translate(0.355469 0.390625)"
        width="31.5"
      />
    </svg>
  );
};
